import React from 'react';
import { Box } from '@mui/material';
import {
  GenericTableAction,
  GenericTableState
} from '../../../Components/GenericTable/genericTableReducer';
import GenericTable from '../../../Components/GenericTable/GenericTable';
import SearchInput from '../../../Components/GenericTable/SearchInput';
import { RecipientsAPIReturn } from '../../types';
import RecipientTableRows from './RecipientTableRows';
import { headerStyles } from './styles';

interface RecipientsProps {
  isFetching: boolean;
  recipients: RecipientsAPIReturn | undefined;
  recipientsState: GenericTableState;
  recipientsDispatch: React.Dispatch<GenericTableAction>;
}

const Recipients: React.FC<RecipientsProps> = ({
  isFetching,
  recipients,
  recipientsState,
  recipientsDispatch
}) => {
  return (
    <Box>
      <SearchInput dispatch={recipientsDispatch} id="search-box-recipients-tab" />
      <GenericTable
        items={recipients?.data?.recipients || []}
        isLoadingItems={isFetching}
        dispatch={recipientsDispatch}
        tableState={recipientsState.tableState}
        paginationState={recipientsState.searchSettings}
        pagination={{
          totalItems: recipients?.totalItems || 0,
          totalPages: recipients?.totalPages || 0
        }}
        headerStyle={headerStyles}
        TableRows={RecipientTableRows}
        label="recipients"
        titleCellId="name"
        allowMultipleSelection={false}
        customEmptyStateMessage="have been sent emails yet"
      />
    </Box>
  );
};

export default Recipients;
